// extracted by mini-css-extract-plugin
export default {"feature-row":"styles_feature-row__yXm2X"};